const searchContainer = document.querySelector('.px-site-document-pagesearch ul')

if(searchContainer && !searchContainer.hasChildNodes()) {
    searchContainer.closest('.px-site-document-pagesearch').querySelector('form').insertAdjacentHTML(
        'afterend', '<div class="search--info">Keine Ergebnisse gefunden</div>'
      );
}
